import { render, staticRenderFns } from "./percent.vue?vue&type=template&id=f21d7b5a&"
import script from "./percent.vue?vue&type=script&lang=js&"
export * from "./percent.vue?vue&type=script&lang=js&"
import style0 from "./percent.vue?vue&type=style&index=0&id=f21d7b5a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports